import { post, get } from '@/axios/method';


// 获取资源内容
export const getResourceContent = (data) => post('/api/dm/scrm/proxy/https', data);

// 获取一书多码的内容
export const getBookUnitContent = (data) => post('/api/dm/market/course-note/queryCourseNoteBook', data);
